import React from 'react';
import { LogsProps } from './logs.config';
import { actionColorsInForm } from 'src/app/pages/Administration/tabs/LogsTab/logs.config';
import './logs.scss';
import { useTranslation } from 'react-i18next';
import { translateFieldsInLogsText } from 'src/app/helpers/translateFieldsInLogsText.helper';
import Popover from 'antd/es/popover';
import Table from 'antd/es/table/Table';

const Logs: React.FC<LogsProps> = ({ logsData }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('administration.logs.user'),
      dataIndex: 'user',
      key: 'user',
      width: '10%',
      render: (text: string) => <span style={{ color: '#666' }}>{text === '-' ? t('general.deletedUser') : text}</span>,
    },
    {
      title: t('administration.logs.action'),
      dataIndex: 'action',
      key: 'action',
      width: '14%',
      render: (text: keyof typeof actionColorsInForm) => (
        <span style={{ color: actionColorsInForm[text] || actionColorsInForm.Unknown }}>
          {t(`administration.logs.${text}`)}
        </span>
      ),
    },
    {
      title: t('administration.logs.details'),
      dataIndex: 'details',
      key: 'details',
      width: '30%',
      render: (text: string) => {
        const isJsonString = (str: string) => {
          try {
            JSON.parse(str);
            return true;
          } catch (e) {
            return false;
          }
        };

        if (isJsonString(text)) {
          const json = JSON.parse(text);

          const generateMessage = (data: any) => {
            let messages = [];
            for (let key in data) {
              const { field, from, to } = data[key];
              if (field !== undefined && from !== undefined && to !== undefined) {
                const message = (
                  <div key={key}>
                    <span
                      style={{
                        fontWeight: 'bold',
                      }}
                    >
                      {field}:{' '}
                    </span>
                    <span style={{ color: 'gray', textDecoration: 'line-through' }}>{from}</span>
                    <span>
                      {' '}
                      --{'>'} {to}
                    </span>
                  </div>
                );
                messages.push(message);
              }
            }

            if (messages.length === 0) {
              return <div>User has been updated the form but no changes were made between old and new values.</div>;
            }

            return messages;
          };

          const visibleText = `${json.realLifeSupportId} has been updated with the following changes:`.slice(0, 30);

          return (
            <Popover
              content={
                <div>
                  <div style={{ marginBottom: 6 }}>
                    <span>
                      <span
                        style={{
                          fontWeight: 'bold',
                        }}
                      >
                        {json.realLifeSupportId}
                      </span>{' '}
                      has been updated with the following changes:
                    </span>
                  </div>
                  {generateMessage(json)}
                </div>
              }
            >
              <span>{visibleText}...</span>
            </Popover>
          );
        } else {
          const translatedText = translateFieldsInLogsText(text);

          const visibleText = translatedText.slice(0, 30);
          return (
            <Popover content={<div>{translatedText}</div>}>
              <span style={{ color: '#666' }}>{visibleText}...</span>
            </Popover>
          );
        }
      },
    },
    {
      title: t('administration.logs.timestamp'),
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: '12%',
      render: (text: string) => <span style={{ color: '#666' }}>{text}</span>,
    },
  ];

  return (
    <Table id="logs-in-form" columns={columns} dataSource={logsData} pagination={false} style={{ color: '#999' }} />
  );
};

export default Logs;
